
<main>
	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link href="https://fonts.googleapis.com/css2?family=Jost:wght@900&display=swap" rel="stylesheet"> 
	<h1 class="animate__animated animate__headShake">TIC <br>TAC<br> TOE</h1>

	<h3 id="message">Diese Seite gibt es nicht.</h3>
    <button on:click={main_page} id="back" class="button is-danger hvr-grow">Zurück</button>

	<p id="credits"> Made with ❤️ by smorrin and JGStyle.</p>
</main>

<script>
    import 'animate.css'
    import 'bulma/css/bulma.css'
    import { push } from 'svelte-spa-router'

    function main_page(){
        push('/')
    }

</script>


<style>
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

	main {
		text-align: center;
		padding: 1em;
		max-width: none;
		width: 100vw;
		height: 100vh;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	:global(body){
		background-color: rgb(26, 26, 26);
	}

	h1 {
		color: #ffffff;
		
		text-transform: uppercase;
		font-size: 6em;
		font-weight: 100;
		font-family: 'Jost', sans-serif;

		line-height: 80%;
	}

	h3 {
		color: #ffffff;
		
		text-transform: uppercase;
		font-size: 2.5em;
		font-weight: 100;
		font-family: 'Roboto', sans-serif;

	}

	#credits {
		position: absolute;
		bottom: 10px;
	}

    #message, #back{
        margin-top: 20px;
    }


	@media (max-width: 500px) {
		main {
			max-width: 240px;
		}
		.right-input {
			width:100%;
		}
		.choose {
			display:inline;
		}
		.center {
			width: 100%;
		} 
		.right {
			margin-top: 20px;
		}
	}
	@media (prefers-color-scheme: light) {
		h1, h3 {
			color: #000000;
		}
		:global(body){
		background-color: white;
		}
		
	}

    .hvr-grow {
    display: inline-block;
    vertical-align: middle;
    transform: translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    transition-duration: 0.3s;
    transition-property: transform;
	}

	.hvr-grow:hover,
	.hvr-grow:focus,
	.hvr-grow:active {
		transform: scale(1.1);
	}
</style>